var CommTopicFilter = React.createClass({
  propTypes: {
    communities: React.PropTypes.arrayOf(React.PropTypes.object),
    topics: React.PropTypes.arrayOf(React.PropTypes.object),
    selectedCommunityID: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    selectedTopicID: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    onCommunityChanged: React.PropTypes.func,
    onTopicChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      communities: [],
      topics: [],
      selectedCommunityID: 0,
      selectedTopicID: 0
    }
  },
  communityChanged(id) {
    if (this.props.onCommunityChanged) {
      this.props.onCommunityChanged(id);
    }
  },
  topicChanged(id) {
    if (this.props.onTopicChanged) {
      this.props.onTopicChanged(id);
    }
  },
  showCommunities() {
    return this.props.selectedCommunityID == 0;
  },
  getItems() {
    if (this.showCommunities()) {
      return this.getCommunityItems();
    } else {
      return this.getTopicItems();
    }
  },
  getCommunityItems() {
    return this.props.communities.map(comm => {
      return (
        <li className="filter__item" key={comm.id}>
          <a href="#" className="filter__link" onClick={this.communityChanged.bind(this, comm.id)}>{comm.name}</a>
        </li>
      )
    })
  },
  getTopicItems() {
    if (this.props.selectedTopicID != 0) return null;

    return this.props.topics.map(topic => {
      return (
        <li className="filter__item -in2" key={topic.id}>
          <a href="#" className="filter__link" onClick={this.topicChanged.bind(this, topic.id)}>{topic.name}</a>
        </li>
      )
    })
  },
  getDefaultItems() {
    if (this.props.selectedCommunityID == 0) return null;

    let allCommunities =  (
      <li className="filter__item" key="_all">
        <a href="#" className="filter__link -back icon-link" onClick={this.communityChanged.bind(this, "")}>
          <i className="glyphicon glyphicon-menu-left"> </i><span className="icon-link__text">{Labels.getLabel("All Communities")}</span>
        </a>
      </li>
    )

    let isCommunityActive = this.props.selectedTopicID == 0;
    let comm = this.props.communities[0];
    let communityItem;

    if (isCommunityActive) {
      communityItem = <li className="filter__item -in1 -active" key="_activeComm">{comm.name}</li>
    } else {
      communityItem = (
        <li className="filter__item" key="_allTopics">
          <a href="#" className="filter__link -back icon-link" onClick={this.topicChanged.bind(this, "")}>
            <i className="glyphicon glyphicon-menu-left"> </i><span className="icon-link__text">{comm.name}</span>
          </a>
        </li>
      )
    }

    let items = [ allCommunities, communityItem ];

    let topic = this.props.topics[0];
    let topicItem;

    if (!isCommunityActive) {
      topicItem = <li className="filter__item -in1 -active" key="_activeTopic">{topic.name}</li>
      items.push(topicItem);
    }

    return items;
  },
  render() {
    if (this.props.communities.length == 0) {
      return <span />;
    }

    let items = this.getItems();
    let defaultItems = this.getDefaultItems();

    return (
      <BrowseFilter title={Labels.getLabel("Communities")}>
        <CollapsingFilterList
          defaultItems={defaultItems}
          items={items} />
      </BrowseFilter>
    )
  }
});